import { defineStore } from "pinia";

export const useControlSheetStore = defineStore("control_sheet", {
    state: () => {
        return {
            levels: [] as string[]
        }
    }
});
